


export function addHttpsToUrl( url ) {
    if(  url.startsWith("https://") || url.startsWith("http://") || url.startsWith("tel:+") || url.startsWith("mailto:")) {
        return url;
    }
    return `https://${url}`;
}